import PropTypes from "prop-types";
import Modal from "@visiblethread/react-components/dist/components/Modal";
import {
  runHideAnimation,
  ANIMATION_DURATION,
} from "components/SlidingPanel/helpers";
import PanelContent from "components/SlidingPanel/PanelContent";

const SlidingPanel = ({
  children,
  panelRef,
  dataTestId,
  className,
  onDismiss,
}) => {
  return (
    <Modal
      modalRef={panelRef}
      tabIndex={0}
      show
      onDismiss={onDismiss}
      backdrop={true}
      className={`vt_sliding_panel ${className}`}
      data-testid={dataTestId}
    >
      {children}
    </Modal>
  );
};

SlidingPanel.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  panelRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  dataTestId: PropTypes.string,
  className: PropTypes.string,
  // Function which will be executed on cross click
  onDismiss: PropTypes.func,
};

export {
  // Put your Modal.Body blocks into PanelContent. It will provide scrolling logic
  PanelContent,
  // Run this function before close panel to show hide animation
  runHideAnimation,
  // Can be used in setTimeout to close panel after animation
  ANIMATION_DURATION,
};

export default SlidingPanel;
